import React, { useState } from 'react';
import { Navbar, Nav, Container, Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import LoginModal from './LoginModal';
import RegisterModal from './RegisterModal';
import RequestModal from './RequestModal';
import './Navbar.css';

const AppNavbar = () => {
  const { t, i18n } = useTranslation();
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showRegisterModal, setShowRegisterModal] = useState(false);
  const [showRequestModal, setShowRequestModal] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const handleShowLoginModal = () => setShowLoginModal(true);
  const handleShowRequestModal = () => setShowRequestModal(true);
  const handleCloseLoginModal = () => setShowLoginModal(false);
  const handleShowRegisterModal = () => setShowRegisterModal(true);
  const handleCloseRegisterModal = () => setShowRegisterModal(false);
  const handleCloseRequestModal = () => setShowRequestModal(false);

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
  };

  const handleNavItemClick = () => {
    if (window.innerWidth <= 992) {
      setExpanded(false);
    }
  };

  return (
    <Navbar 
      expand="lg" 
      className="navbar-custom" 
      sticky="top"
      expanded={expanded}
      onToggle={(isOpen) => setExpanded(isOpen)}
    >
      <style>
        {`
          .navbar-custom {
            background: linear-gradient(to right, rgb(128, 173, 242), rgb(72, 148, 234));
            padding: 1rem 1.5rem;
            border-bottom: 4px solid rgb(182, 162, 15);
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          }
          
          .nav-link-custom {
            font-size: 1rem;
            padding: 0.5rem 1rem;
            color: #ffffff;
            font-weight: 500;
            transition: color 0.3s, transform 0.3s;
          }
          
          .nav-link-custom:hover {
            color: #ff6347;
            transform: scale(1.1);
          }
          
          .navbar-logo {
            max-height: 50px;
          }
          
          .cta-button {
            background-color: rgb(12, 78, 131);
            color: #ffffff;
            font-weight: bold;
            border: none;
            padding: 0.5rem 1.5rem;
            border-radius: 25px;
            transition: background-color 0.3s, box-shadow 0.3s;
          }
          
          .cta-button:hover {
            background-color: #ff7f50;
            box-shadow: 0 4px 8px rgba(255, 99, 71, 0.3);
          }

          .social-icons a {
            color: #ffffff;
            font-size: 1.2rem;
            margin: 0 0.5rem;
            transition: color 0.3s;
          }

          .social-icons a:hover {
            color: #ff6347;
          }

          @media (max-width: 992px) {
            .cta-button {
              margin-top: 1rem;
            }
            .navbar-nav {
              align-items: flex-start;
              padding: 1rem 0;
            }
            .nav-link-custom {
              padding: 0.5rem 1.5rem;
            }
            .social-icons {
              justify-content: flex-start;
              padding: 1rem 1.5rem;
            }
          }
        `}
      </style>

      <Container>
        <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
          <img
            src="/images/ag3.png"
            alt="Brand Logo"
            className="navbar-logo"
            style={{ width: '160px', height: '160px' }}
          />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto d-flex align-items-lg-center">
            <Nav.Link 
              as={Link} 
              to="/" 
              className="nav-link-custom" 
              onClick={handleNavItemClick}
            >
              {t('home')}
            </Nav.Link>
            <Nav.Link 
              as={Link} 
              to="/about" 
              className="nav-link-custom" 
              onClick={handleNavItemClick}
            >
              {t('aboutUs')}
            </Nav.Link>

            <Nav.Link 
              as={Link} 
              to="/quality-assurance" 
              className="nav-link-custom" 
              onClick={handleNavItemClick}
            >
              {t('qualityAssurance')}
            </Nav.Link>

            <Nav.Link 
              as={Link} 
              to="/all-products" 
              className="nav-link-custom" 
              onClick={handleNavItemClick}
            >
              {t('products')}
            </Nav.Link>
            <Nav.Link 
              className="nav-link-custom" 
              onClick={() => {
                handleShowRequestModal();
                handleNavItemClick();
              }}
            >
              {t('purchaseRequest')}
            </Nav.Link>
            <Nav.Link 
              as={Link} 
              to="/blogs" 
              className="nav-link-custom" 
              onClick={handleNavItemClick}
            >
              {t('blogs')}
            </Nav.Link>
            <Nav.Link 
              as={Link} 
              to="/contact" 
              className="nav-link-custom" 
              onClick={handleNavItemClick}
            >
              {t('contactUs')}
            </Nav.Link>

            <Nav.Link 
              className="nav-link-custom" 
              onClick={() => {
                handleShowRegisterModal();
                handleNavItemClick();
              }}
            >
              {t('register')}
            </Nav.Link>
            <Nav.Link 
              className="nav-link-custom" 
              onClick={() => {
                handleShowLoginModal();
                handleNavItemClick();
              }}
            >
              {t('login')}
            </Nav.Link>

            <div className="social-icons d-flex align-items-center">
              <a
                href="https://web.facebook.com/profile.php?id=100064115766335"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-facebook-f"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-twitter"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-instagram"></i>
              </a>
            </div>

            <Dropdown className="ms-lg-3 mt-2 mt-lg-0">
              <Dropdown.Toggle variant="link" id="language-dropdown" className="nav-link-custom">
                {t('language')}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={() => {
                  changeLanguage('en');
                  handleNavItemClick();
                }}>
                  {t('english')}
                </Dropdown.Item>
                <Dropdown.Item onClick={() => {
                  changeLanguage('am');
                  handleNavItemClick();
                }}>
                  {t('amharic')}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>

      <LoginModal show={showLoginModal} handleClose={handleCloseLoginModal} />
      <RegisterModal show={showRegisterModal} handleClose={handleCloseRegisterModal} />
      <RequestModal show={showRequestModal} handleClose={handleCloseRequestModal} />
    </Navbar>
  );
};

export default AppNavbar;